<template>
  <v-layout align-center column fill-height justify-center>
    <v-icon color="grey" style="font-size: 1000%;">cloud_off</v-icon>
    <h2>{{ $t('entity-x-with-id-n-cant-be-viewed', [displayEntityName, requestedId]) }}</h2>
    <div>{{ $t('entity-x-cant-be-displayed', [displayEntityName]) }}</div>
    <div>{{ $t('entity-deleted-or-no-permission') }}</div>
  </v-layout>
</template>

<script>
export default {
  name: 'entity-not-found',
  data () {
    return {
      entity: this.$route.params.entity,
      requestedId: this.$route.params.id
    }
  },
  computed: {
    displayEntityName () {
      return this.$tc(`${this.entity}.entity-name`, 2)
    }
  }
}
</script>
